import React, { useState, useEffect } from 'react'
import { Plus, Search, Loader } from 'lucide-react'
import toast from 'react-hot-toast'

export default function BrandsPage() {
  const [loading, setLoading] = useState(true)
  const [searchTerm, setSearchTerm] = useState('')

  useEffect(() => {
    // Simulate loading
    const timer = setTimeout(() => {
      setLoading(false)
    }, 500)
    return () => clearTimeout(timer)
  }, [])

  if (loading) {
    return (
      <div className="flex items-center justify-center h-96">
        <div className="flex flex-col items-center gap-3">
          <Loader className="w-12 h-12 text-[#6D3A0D] animate-spin" />
          <p className="text-gray-600">Loading brands...</p>
        </div>
      </div>
    )
  }

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex justify-between items-center">
        <h1 className="text-3xl font-bold text-[#6D3A0D]">Brands</h1>
        <button
          onClick={() => toast.success('Brand creation coming soon')}
          className="flex items-center gap-2 px-4 py-2 bg-[#6D3A0D] text-white rounded-lg hover:bg-[#5D2A0D] transition"
        >
          <Plus size={20} />
          Add Brand
        </button>
      </div>

      {/* Search Bar */}
      <div className="flex gap-4">
        <div className="flex-1 relative">
          <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={20} />
          <input
            type="text"
            placeholder="Search brands..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-full pl-10 pr-4 py-2 border-2 border-[#F6EEE7] rounded-lg focus:outline-none focus:ring-2 focus:ring-[#6D3A0D]"
          />
        </div>
      </div>

      {/* Content */}
      <div className="bg-white rounded-xl border-2 border-[#F6EEE7] p-8 text-center">
        <p className="text-gray-500 text-lg">Brands management feature coming soon</p>
        <p className="text-gray-400 text-sm mt-2">This page will allow you to manage product brands</p>
      </div>
    </div>
  )
}
